import { api } from "../helper/apiClient.js";

function getSession() {
  try {
    const raw = sessionStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : null;
    return {
      condominio: user?.condominio ?? null,
      token: user?.token ?? null,
      user,
    };
  } catch {
    return { condominio: null, token: null, user: null };
  }
}

/** Resolve token: usa opts.token ou pega do sessionStorage */
function resolveToken(opts = {}) {
  const sessionToken = getSession()?.token ?? null;
  const token = opts.token ?? sessionToken;
  if (!token) {
    return { error: { ok: false, status: 0, error: "Sessão inválida: token ausente" } };
  }
  // garante que o token vá para a api, preservando outras opções
  return { opts: { ...opts, token } };
}

/** POST /users */
export async function criarUsuario(payload, opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api("/users", {
    method: "POST",
    body: payload,
    ...r.opts,
  });
}

/** GET /users/all */
export default async function listarUsuarios(opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api("/users/all", {
    method: "GET",
    ...r.opts,
  });
}

/** GET /users/by-condominio?condominio=... */
export async function listarUsuariosPorCondo(condominio, opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api("/users/by-condominio", {
    method: "GET",
    params: { condominio },
    ...r.opts,
  });
}

/** GET /users/exists?condominio=...&user=... */
export async function verificarUsuarioExiste(condominio, user, opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api("/users/exists", {
    method: "GET",
    params: { condominio, user },
    ...r.opts,
  });
}

/** PUT /users/update/{userId} */
export async function atualizarUsuario(userId, payload, opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api(`/users/update/${encodeURIComponent(userId)}`, {
    method: "PUT",
    body: payload,
    ...r.opts,
  });
}

/** DELETE /users/delete/{id}/{user} */
export async function deletarUsuario(id, user, opts = {}) {
  const r = resolveToken(opts);
  if (r.error) return r.error;

  return api(`/users/delete/${encodeURIComponent(id)}/${encodeURIComponent(user)}`, {
    method: "DELETE",
    ...r.opts,
  });
}